import React, { memo, useState } from 'react';
import WarningBar from 'components/shared/WarningBar';
import { WarningLevel } from 'components/shared/WarningLevel';
import useGetNotes from 'domain/alert/hooks/useGetNotes';
import useDismissedAlerts from 'domain/alert/hooks/useDismissedAlerts';
import compareDateToToday from 'utils/compareDateToToday';

function WarningWrapper() {
  const { data: notes } = useGetNotes();
  const { dismiss, isDismissed } = useDismissedAlerts();
  const [closedIds, setClosedIds] = useState<Set<string>>(new Set());

  const visibleNotes = notes?.filter(
    note =>
      compareDateToToday(note.expirationDatetimeUtc) &&
      note.isVisible &&
      note.publicId &&
      !isDismissed(note.publicId) &&
      !closedIds.has(note.publicId),
  );

  const currentNote = visibleNotes?.[0];

  if (!currentNote) return null;

  const handleClose = () => {
    if (!currentNote.publicId) return;
    setClosedIds(prev => new Set(prev).add(currentNote.publicId!));
  };

  const handleDismissPermanently = () => {
    if (!currentNote.publicId) return;
    dismiss(currentNote.publicId, currentNote.expirationDatetimeUtc);
  };

  return (
    <WarningBar
      key={currentNote.publicId}
      level={currentNote.content as WarningLevel}
      message={currentNote.title}
      isClosable={true}
      isGlobal={true}
      link={currentNote.externalInformationUrl}
      onClose={handleClose}
      onDismissPermanently={handleDismissPermanently}
    />
  );
}

export default memo(WarningWrapper);
